import moment from 'moment';

import {
  formatarMilhar,
  formatarMoedaIMask,
  formatarPorcentagem,
} from './formatador';

/**
 * Transform antd to export
 * @param {Array} headersAntd
 * @param {Array} rowsAntd
 */
export function prepareDataAntdTableToCsv(headersAntd = [], rowsAntd = []) {
  rowsAntd.forEach(row => {
    if (row.aderencia) {
      row.aderencia = formatarPorcentagem(row.aderencia);
    }
    if (row.carregado_hoje) {
      row.carregado_hoje = formatarPorcentagem(row.carregado_hoje);
    }
    if (row.cidade_expedidor || row.cidade_remetente || row.cidade_origem) {
      row.origem =
        row.cidade_expedidor || row.cidade_remetente || row.cidade_origem;
    }
    if (row.cidade_recebedor || row.cidade_destinatario || row.cidade_destino) {
      row.destino =
        row.cidade_recebedor || row.cidade_destinatario || row.cidade_destino;
    }
    if (row._id && row._id.estado_cliente) {
      row.estado_cliente = row._id.estado_cliente;
    }
    if (row.embarcado || row.embarcado === 0) {
      row.embarcado_ton = `${row.embarcado} (${formatarMilhar(
        row.qtd_peso_total_carregado_hoje
      )}T)`;
    }
    if (row.valor_empresa) {
      row.valor_empresa = formatarMoedaIMask(row.valor_empresa);
    }
    if (row.peso) {
      row.peso = `${formatarMilhar(row.peso)}T`;
    }
    if (row.data_acao) {
      row.data_acao = moment(new Date(row.data_acao))
        .add(3, 'hours')
        .format('DD/MM/YYYY HH:mm');
    }
  });

  headersAntd.forEach(header => {
    if (header.key === 'cidade_origem') {
      header.key = 'origem';
    }
    if (header.key === 'cidade_destino') {
      header.key = 'destino';
    }
    if (header.key === 'embarcado') {
      header.key = 'embarcado_ton';
    }
  });

  return {
    headers: headersAntd.map(header => ({
      label: header.title.props.title,
      key: header.key,
    })),
    rows: rowsAntd,
  };
}
